export default {

  mudaName (context , value) {
    context.commit('MUDAR_NAME', value)
  },
  builderInfo (context , value) {
    // console.log(value)
    context.commit('SETBUILDERINFO', value)
  },
  currentInfo (context , value) {
    // console.log(value)
    context.commit('SETCURRENTINFO', value)
  },
  redeSocial (context , value) {
    // console.log(value)
    context.commit('SET_REDE_SOCIAL', value)
  }
}


// WEBPACK FOOTER //
// ./src/store/actions.js